import React from 'react';
import { Dialog, DialogContent, DialogTitle, IconButton, Tooltip } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';
import { Minimize2 } from 'lucide-react';

interface FullScreenContentDialogProps {
  open: boolean;
  title?: React.ReactNode;
  onClose: () => void;
  exitTooltip: string;
  children: React.ReactNode;
  contentSx?: SxProps<Theme>;
}

const FullScreenContentDialog: React.FC<FullScreenContentDialogProps> = ({
  open,
  title,
  onClose,
  exitTooltip,
  children,
  contentSx,
}) => {
  return (
    <Dialog open={open} onClose={onClose} fullScreen>
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        {title}

        <Tooltip title={exitTooltip}>
          <IconButton onClick={onClose}>
            <Minimize2 size={18} />
          </IconButton>
        </Tooltip>
      </DialogTitle>

      <DialogContent sx={contentSx}>{children}</DialogContent>
    </Dialog>
  );
};

export default FullScreenContentDialog;
